<template>
<div class='custom-progress-bar-content'>

  <div class='custom-progress-bar-content__background_parallelogram' :style='{"--pb-bg-width": `calc(${width}*1px)`, "--pb-bg-height": `calc(${height*0.7}*1px)`}'/>
  <div class='custom-progress-bar-content__background_progress' :style='{"--pb-p-width": `calc(${width*progress/100}*1px)`, "--pb-p-height": `calc(${height}*1px)`}' />
  <div class='custom-progress-bar-content__legend'>
    <div class='custom-progress-bar-content__legend__label'>{{label}}</div>
    <div class='custom-progress-bar-content__legend__progress_number'>{{progress}}%</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'CustomProgressBar',
  props: {
    label: {
      type: String,
      required: false,
    },
    progress: {
      required: false,
      type: Number,
      default: 0,
    },
    width: {
      required: false,
      type: Number,
      default: 250,
    },
    height: {
      required: false,
      type: Number,
      default: 25,
    },
  },
  components: {
  },
  computed: {
  },
};
</script>

<style scoped lang='scss'>
@import '~@/assets/styles/design-system';

.custom-progress-bar-content {
  display: flex;
  flex-direction: column;
  align-content: flex-start;

  &__background_parallelogram {
    width: var(--pb-bg-width);
    height: var(--pb-bg-height);
    transform: skew(-20deg);
    background: var(--text-secondary, #9fa5b4);
    opacity: 0.2;
    box-shadow: rem(3) rem(-3) 0 0 rgba(0,0,0,0.59);
  }

  &__background_progress {
    margin-top: calc(-1 * var(--pb-p-height));
    width: var(--pb-p-width);
    height: var(--pb-p-height);
    transform: skew(-20deg);
    background-image: repeating-linear-gradient(
        -90deg,
        var(--btn-primary-bg, var(--brand-primary, #8E30D0)) rem(-6),
        transparent rem(-5),
        transparent rem(2),
        var(--btn-primary-bg, var(--brand-primary, #8E30D0)) rem(3),
        var(--btn-primary-bg, var(--brand-primary, #8E30D0)) rem(30),
    );
    animation: progress_bar_kf 1s ease-in-out;
    transition: width 1s ease-in-out;
  }
  &__legend{
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: $font-size-md;
    &__progress_number {
      font-family: $font-family-black;
      color: var(--success-text, #00bfb3);
      display: flex;
      justify-content: right;
      margin-top: rem(5);
    }
    &__label {
      font-family: $font-family-semibold;
      color: var(--text-primary, #1a1e22);
      display: flex;
      justify-content: left;
      margin-top: rem(5);
      margin-left: rem(-3);
    }
  }
  @keyframes progress_bar_kf {
    0% { width: 0; }
    100% { width:  var(--pb-p-width); }
  }
}
</style>
